export default __webpack_public_path__ + "static/media/drop.43388244.jpeg";